export const routeConfig = {
  meta: {
    title: '登录',
  },
  params: ':type?',
};
